import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';

export interface BookingInfo {
  id: string;
  scheduledAt: string;
  status: string;
  sessionType: string;
  amountNgn: number;
  dailyRoomUrl?: string;
  therapist: {
    id: string;
    displayName: string;
    bio: string;
    gender: string;
    ratingAvg: number;
    specializations: string[];
  };
  payment?: { status: string; amountNgn: number };
}

export interface AssessmentResult {
  id: string;
  phq9Score: number;
  gad7Score: number;
  matchedSpecializations: string[];
  completedAt: string;
}

export interface WalletSummary {
  totalAvailableNgn: number;
}

export function useClientDashboard() {
  return useQuery({
    queryKey: ['client-dashboard'],
    queryFn: async () => {
      const [bookings, assessment, wallet] = await Promise.all([
        api.get<BookingInfo[]>('/bookings/my'),
        api.get<AssessmentResult | null>('/assessments/latest').catch(() => null),
        api.get<WalletSummary>('/referrals/wallet').catch(() => null),
      ]);
      return { bookings, assessment, wallet };
    },
  });
}
